/**
 * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
 */
import { combineReducers } from 'redux';

function storiesList(state = global.__PRELOADED_STATE.stories) {
    return state;
}

function advertisement(state = global.__PRELOADED_STATE.advertisement) {
    return state;
}

/**
 * News reducer
 * @param state
 * @returns {Array}
 */

export default combineReducers({
    storiesList,
    advertisement
});



// WEBPACK FOOTER //
// ./src/js/News/news.reducer.js